import React, { useState, useEffect } from "react";
import clsx from "clsx";

import styles from "./Spinner.module.scss";

export interface ISpinner {
  delay?: number;
  spinColor?: "white" | "black";
  className?: string;
}

const Spinner = ({
  delay = 0,
  spinColor = "white",
  className = "",
}: ISpinner) => {
  const [isReady, setIsReady] = useState(delay === 0);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (!isReady) {
      timer = setTimeout(() => setIsReady(true), delay);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isReady, delay]);

  return isReady ? (
    <div className={clsx(styles.spinner, styles[spinColor], className)} />
  ) : null;
};

export default Spinner;
